// libs
import Slider from '@mui/material/Slider'

export default Slider
